var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_96841)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#7478DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1872 18.9616L26.6992 15.4913L23.375 13.938L26.6992 12.3516L28.1872 8.91431L29.7069 12.3516L32.9995 13.938L29.7069 15.4913L28.1872 18.9616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0623 14.3938L14.1154 12.1854L12 11.1969L14.1154 10.1873L15.0623 8L16.0294 10.1873L18.1247 11.1969L16.0294 12.1854L15.0623 14.3938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1793 21.312L24.1661 24.3162C24.5042 24.6563 24.8946 24.8221 25.3372 24.8135C25.7798 24.8049 26.164 24.6241 26.4898 24.2711C26.8156 23.9181 26.9744 23.5106 26.9661 23.0485C26.9579 22.5865 26.7847 22.1854 26.4466 21.8453L20.5856 15.9502C20.2475 15.6101 19.8571 15.4444 19.4145 15.453C18.9719 15.4616 18.5877 15.6424 18.2619 15.9954L12.615 22.1138C12.2892 22.4668 12.1304 22.8743 12.1386 23.3364C12.1469 23.7985 12.32 24.1995 12.6582 24.5396C12.9963 24.8797 13.3867 25.0455 13.8293 25.0369C14.2719 25.0283 14.6561 24.8475 14.9819 24.4945L17.8597 21.3765L18.0161 30.1556C18.025 30.6561 18.1891 31.067 18.5085 31.3882C18.8278 31.7094 19.2272 31.8654 19.7067 31.8561C20.1862 31.8468 20.5798 31.6754 20.8875 31.342C21.1952 31.0087 21.3446 30.5917 21.3356 30.0911L21.1793 21.312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_96841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterHover);
export default __webpack_public_path__ + "static/media/EnterHover.1fb092be6c7b24ddc04a9b2a0b53589f.svg";
export { ForwardRef as ReactComponent };